import React, { Component } from "react";

import {
  CButton,
  CFormGroup,
  CInputGroup,
  CInputGroupPrepend,
  CSwitch,
  CInputGroupText,
  CLabel,
  CInput,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CSelect,
  CSpinner,
  CRow,
  CCol,
  CBadge
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import Select from "react-select";

import URL from "../../config/api";
import axios from "../../config/axios";
import {
  getAbilityName,
  getDisciplineName,
  getDisciplines
} from "../../utils/bncc";
import Uploader from "../Uploader/uploader";

class NewContentModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      // activity: null,
      segment: null,
      segments: [],
      // serie: null,
      series: [],
      ability: null,
      abilities: [],
      module: null,
      modules: [],
      discipline: null,
      disciplines: [],
      all_abilities: [],
      name: "",
      resume: "",
      objective: "",
      image: "",
      path: "",
      year: "",
      author: "",
      creating: false,
      printable: false
    };
  }

  async componentDidMount() {
    axios
      .all([
        axios.get(`${URL.api}classification/ability/list`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }),
        axios.get(`${URL.api}classification/segment/list`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }),
        axios.get(`${URL.api}classification/discipline/list`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
      ])
      .then(
        axios.spread(
          (respAbility, respSegment, respDiscipline) => {
            this.setState({
              loading: false,
              all_abilities: respAbility.data.data,
              segments: respSegment.data.data,
              disciplines: respDiscipline.data.data
            });
          },
          error => {
            this.error("Não foi possível obter as informações");
          }
        )
      );
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  enviar(value) {
    this.setState({ creating: true });

    let obj = {
      loggedUser: this.props.user.user.id,
      name: this.state.name,
      type_id: this.props.id,
      path: this.state.path,
      ability_id: this.state.ability.value,
      module_id: this.state.module.value,
      released: true,
      private: true, // Mudança feita para que o conteúdo adicionado pelo usuário não apareça na biblioteca.
      flash: false,
      user_id: this.props.user.user.id,
      skin_id: 1,
      tag: null,
      resume: this.state.resume,
      objective: this.state.objective,
      image: this.state.image,
      author: this.state.author,
      language_id: 1,
      status: "Liberado",
      year: this.state.year,
      source_id: 2,
      difficulty_level_id: 1,
      series: this.state.series.map(serie => serie.value),
      printable: this.state.printable
    };

    if (!obj.name) {
      toastr.error("Falha", "Favor preencher o nome do conteúdo.");
      this.setState({ creating: false });
      return;
    }

    if (!obj.year) {
      toastr.error("Falha", "Favor preencher o ano do conteúdo.");
      this.setState({ creating: false });
      return;
    }

    if (!obj.author) {
      toastr.error("Falha", "Favor preencher o autor do conteúdo.");
      this.setState({ creating: false });
      return;
    }

    if (this.state.path === undefined) {
      toastr.error(
        "Falha",
        "Favor fazer o envio do arquivo no início da página."
      );
      this.setState({ creating: false });
    } else if (this.state.image === undefined) {
      toastr.error(
        "Falha",
        "Favor fazer o envio da imagem no início da página."
      );
      this.setState({ creating: false });
    } else {
      axios
        .post(`${URL.api}content/los/insert`, obj, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(
          resp => {
            if (resp.data.success) {
              this.props.onImport({ ...obj, id: resp.data.data });
              this.setState({ creating: false });
            } else {
              this.error("Não foi possível inserir o conteúdo");
              this.setState({ creating: false });
            }
          },
          error => {
            this.error("Não foi possível inserir o conteúdo");
            this.setState({ creating: false });
          }
        );
    }
  }

  done(uploads) {
    this.setState(() => ({
      image: URL.img + uploads[0]
    }));
  }

  done2(uploads2) {
    this.setState(() => ({
      path: URL.img + uploads2[0]
    }));
  }

  changeSegment(e) {
    const segment = parseInt(e.target.value);

    this.setState({
      segment,
      abilities: [],
      modules: [],
      series: [],
      ability: null,
      module: null,
      discipline: null
    });
  }

  changeDiscipline(e) {
    const { segment } = this.state;
    const discipline = parseInt(e.target.value);
    const ability = this.state.all_abilities;

    let abilities = ability.filter(
      item =>
        item.type === "bncc" &&
        item.series.length &&
        item.series[0].segment_id === segment &&
        item.discipline_id === discipline
    );
    let modules = ability.filter(
      item =>
        item.type === "educandus" &&
        item.series.length &&
        item.series[0].segment_id === segment &&
        item.discipline_id === discipline
    );

    this.setState({
      segment,
      discipline,
      abilities,
      modules,
      series: [],
      ability: null,
      module: null
    });
  }

  render() {
    const seriesAbilities =
      this.state.all_abilities
        .find(item => item.id === this.state.ability?.value)
        ?.series.map(item => ({ label: item.name, value: item.id })) || [];
    const seriesModules =
      this.state.all_abilities
        .find(item => item.id === this.state.module?.value)
        ?.series.map(item => ({ label: item.name, value: item.id })) || [];
    const series = [...seriesAbilities, ...seriesModules].filter(
      (v, i, a) => a.findIndex(item => item.value === v.value) === i
    );

    return (
      <CModal
        show={this.props.show}
        onClose={() => this.props.onClose()}
        size="lg"
        centered
        style={{ overflow: "visible" }}
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>
          <CModalTitle>Importar conteúdo</CModalTitle>
        </CModalHeader>
        <CModalBody style={{ overflow: "visible" }}>
          {this.state.loading ? (
            <div className="h-100 w-100 d-flex align-items-center justify-content-center p-4">
              <CSpinner size="md" color="secondary" />
            </div>
          ) : (
            <div className="px-3 pt-3">
              <CRow>
                <CCol>
                  <CLabel className="d-flex align-items-center mb-2">
                    Arquivo do conteúdo
                    {this.state.path && (
                      <CBadge
                        color="primary"
                        className="ml-2 text-ellipsis"
                        href={this.state.path}
                        target="_blank"
                      >
                        Abrir
                      </CBadge>
                    )}
                  </CLabel>
                  <Uploader
                    type="lo"
                    maxFiles={1}
                    allowMultiple
                    labelIdle='Arraste e solte seu arquivo ou <span class="filepond--label-action">procure</span>'
                    done={uploads2 => this.done2(uploads2)}
                  />
                </CCol>
                <CCol>
                  <CLabel className="d-flex align-items-center mb-2">
                    Imagem de capa
                    {this.state.image && (
                      <CBadge
                        color="primary"
                        className="ml-2 text-ellipsis"
                        href={this.state.image}
                        target="_blank"
                      >
                        Ver
                      </CBadge>
                    )}
                  </CLabel>
                  <Uploader
                    type="lo"
                    maxFiles={1}
                    acceptedFileTypes={["image/*"]}
                    allowMultiple
                    labelIdle='Arraste e solte sua imagem ou <span class="filepond--label-action">procure</span>'
                    done={uploads => this.done(uploads)}
                  />
                </CCol>
              </CRow>
              <CFormGroup>
                <CLabel>Nome</CLabel>
                <CInputGroup className="flex-nowrap">
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-text-width"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <CInput
                    placeholder="Nome"
                    value={this.state.name}
                    onChange={e => this.setState({ name: e.target.value })}
                  />
                </CInputGroup>
              </CFormGroup>
              <CFormGroup>
                <CLabel>Resumo</CLabel>
                <CInputGroup className="flex-nowrap">
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-text-width"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <CInput
                    placeholder="Resumo"
                    value={this.state.resume}
                    onChange={e => this.setState({ resume: e.target.value })}
                  />
                </CInputGroup>
              </CFormGroup>
              <CFormGroup>
                <CLabel>Objetivo</CLabel>
                <CInputGroup className="flex-nowrap">
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-text-width"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <CInput
                    placeholder="Objetivo"
                    value={this.state.objective}
                    onChange={e => this.setState({ objective: e.target.value })}
                  />
                </CInputGroup>
              </CFormGroup>
              <CRow>
                <CCol>
                  <CFormGroup>
                    <CLabel>Autor</CLabel>
                    <CInputGroup className="flex-nowrap">
                      <CInputGroupPrepend>
                        <CInputGroupText>
                          <i className="fa fa-text-width"></i>
                        </CInputGroupText>
                      </CInputGroupPrepend>
                      <CInput
                        placeholder="Autor"
                        value={this.state.author}
                        onChange={e =>
                          this.setState({ author: e.target.value })
                        }
                      />
                    </CInputGroup>
                  </CFormGroup>
                </CCol>
                <CCol>
                  <CFormGroup>
                    <CLabel>Ano</CLabel>
                    <CInputGroup className="flex-nowrap">
                      <CInputGroupPrepend>
                        <CInputGroupText>
                          <i className="fa fa-text-width"></i>
                        </CInputGroupText>
                      </CInputGroupPrepend>
                      <CInput
                        placeholder="Ano"
                        type="number"
                        value={this.state.year}
                        onChange={e => this.setState({ year: e.target.value })}
                      />
                    </CInputGroup>
                  </CFormGroup>
                </CCol>
              </CRow>
              {parseInt(this.props.id) === 9 && (
                <CFormGroup>
                  <CLabel>Material imprimível</CLabel>
                  <CInputGroup className="flex-nowrap">
                    <CSwitch
                      color="primary"
                      checked={this.state.printable}
                      onChange={e =>
                        this.setState({ printable: e.target.checked })
                      }
                      shape="pill"
                    />
                  </CInputGroup>
                </CFormGroup>
              )}
              <CFormGroup>
                <CLabel>Segmento</CLabel>
                <CInputGroup className="flex-nowrap">
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-text-width"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <CSelect
                    placeholder="Segmento"
                    value={this.state.segment}
                    onChange={e => this.changeSegment(e)}
                  >
                    <option>Segmento</option>
                    {this.state.segments.map(segment => (
                      <option key={segment.id} value={segment.id}>
                        {segment.name}
                      </option>
                    ))}
                  </CSelect>
                </CInputGroup>
              </CFormGroup>
              <CFormGroup>
                <CLabel>{getDisciplineName(this.state.segment)}</CLabel>
                <CInputGroup className="flex-nowrap">
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-text-width"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <CSelect
                    placeholder={getDisciplineName(this.state.segment)}
                    value={this.state.discipline}
                    onChange={e => this.changeDiscipline(e)}
                  >
                    <option>{getDisciplineName(this.state.segment)}</option>
                    {getDisciplines(
                      this.state.segment,
                      this.state.disciplines
                    ).map(discipline => (
                      <option key={discipline.id} value={discipline.id}>
                        {discipline.name}
                      </option>
                    ))}
                  </CSelect>
                </CInputGroup>
              </CFormGroup>
              <CRow>
                <CCol>
                  <CFormGroup>
                    <CLabel>{getAbilityName(this.state.segment)}</CLabel>
                    <CInputGroup className="flex-nowrap">
                      <CInputGroupPrepend>
                        <CInputGroupText>
                          <i className="fa fa-text-width"></i>
                        </CInputGroupText>
                      </CInputGroupPrepend>
                      <Select
                        placeholder={getAbilityName(this.state.segment)}
                        name={getAbilityName(this.state.segment)}
                        options={this.state.abilities.map(item => ({
                          label: `(${item.code}) ${item.description}`,
                          value: item.id
                        }))}
                        value={this.state.ability}
                        className="basic-multi-select flex-1"
                        classNamePrefix="select"
                        onChange={e =>
                          this.setState({ ability: e, series: [] })
                        }
                      />
                    </CInputGroup>
                  </CFormGroup>
                </CCol>
                <CCol>
                  <CFormGroup>
                    <CLabel>Eixo temático BNCC</CLabel>
                    <CInputGroup className="flex-nowrap">
                      <CInputGroupPrepend>
                        <CInputGroupText>
                          <i className="fa fa-text-width"></i>
                        </CInputGroupText>
                      </CInputGroupPrepend>
                      <Select
                        placeholder="Módulo"
                        name="Módulo"
                        options={this.state.modules.map(item => ({
                          label: item.description,
                          value: item.id
                        }))}
                        value={this.state.module}
                        className="basic-multi-select flex-1"
                        classNamePrefix="select"
                        onChange={e => this.setState({ module: e, series: [] })}
                      />
                    </CInputGroup>
                  </CFormGroup>
                </CCol>
              </CRow>
              <CFormGroup>
                <CLabel>Séries</CLabel>
                <CInputGroup className="flex-nowrap">
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-text-width"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <Select
                    isMulti
                    placeholder="Séries"
                    name="Séries"
                    options={series}
                    value={this.state.series}
                    className="basic-multi-select flex-1"
                    classNamePrefix="select"
                    onChange={e => this.setState({ series: e })}
                  />
                </CInputGroup>
              </CFormGroup>
              <CFormGroup className="d-flex justify-content-end">
                <CButton
                  color="primary"
                  className="d-flex justify-content-center align-items-center"
                  onClick={() => this.enviar()}
                  disabled={this.state.creating}
                >
                  <>
                    <span style={this.state.creating ? { opacity: 0 } : null}>
                      Importar
                    </span>
                    {this.state.creating && (
                      <CSpinner
                        size="sm"
                        color="white"
                        style={{ position: "absolute" }}
                      />
                    )}
                  </>
                </CButton>
              </CFormGroup>
            </div>
          )}
        </CModalBody>
      </CModal>
    );
  }
}

const mapStateToProps = state => ({ user: state.user });

export default connect(mapStateToProps, null)(NewContentModal);
